import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import AnimatedPage from '../../../common/AnimatedPage/AnimatedPage';
import { fonts, themes } from '../../../common/themes/themes';
import CurrentSalaryController from '../../../domain/myProfile/salary/CurrentSalary/CurrentSalaryController';
import Warning from './Warning';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../infra/hooks';
import { warningcomplaintService } from '../../../api/services/warningcomplaintService';
import Complaint from './Complaint';

interface propsInter {
  trans: any;
  i18n?: any;
}
interface WarningItem {
  id: string; // or `number` depending on your data
  title: string; // and any other fields in your warnings
}
interface ComplaintItem {
  id: string; // or `number` depending on your data
  title: string; // and any other fields in your warnings
}
const WarningComplaintPresenter: React.FC<propsInter> = ({ trans, i18n }) => {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state);
  const [warningList, setWarningList] = useState<WarningItem[]>([]);
  const [complaintList, setComplaintList] = useState<ComplaintItem[]>([]);
  useEffect(() => {
    CallEmpwarnigandcomplaintlist(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
  }, [selector.authSlice.company_id, selector.authSlice.emp_id]);
  const CallEmpwarnigandcomplaintlist = async (
    companyId: number,
    empId: number,
  ) => {
    await warningcomplaintService
      .empwarnigandcomplaintlist(companyId, empId)
      .then((response) => {
        setWarningList(response?.data?.warnings);
        setComplaintList(response?.data?.complaints);
      })
      .catch((err) => {
        return;
      });
  };
  const handleremoveItemwarning = (id: string) => {
    // Filter out the item with the given ID
    setWarningList((prevList) => prevList.filter((item) => item.id !== id));
  };
  const handleremoveItemcomplaint = (id: string) => {
    // Filter out the item with the given ID
    setComplaintList((prevList) => prevList.filter((item) => item.id !== id));
  };
  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        //marginTop: isHRView ? '' : '4em',
        marginTop: '',
        width: '100vw',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft:
            i18n.language == 'en'
              ? '11em'
              : i18n.language == 'en'
                ? '14em'
                : '',
          marginRight: i18n.language == 'ar' ? '15em' : '',
        }}
      >
        <AnimatedPage>
          <Grid
            container
            style={{
              paddingLeft: '',
            }}
          >
            <Grid
              item
              sx={{
                width: '100%',
              }}
            >
              <Grid
                container
                style={{
                  width: 'auto',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  borderRadius: '10px',
                  opacity: '1',
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '1em',
                  paddingBottom: '1em',
                  paddingLeft: '1em',
                  paddingRight: '1em',
                }}
              >
                <Grid item xs={9}>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.header,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Warning & Complaint')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={3}
                style={{
                  width: 'auto',
                  marginTop: '0.5em',
                }}
              >
                {warningList.length > 0 && (
                  <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Warning
                      trans={t}
                      warningListData={warningList}
                      removeID={handleremoveItemwarning}
                    />
                    <Box style={{ marginTop: '1.75em' }} />
                  </Grid>
                )}
                {complaintList.length > 0 && (
                  <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Complaint
                      trans={t}
                      complaintListData={complaintList}
                      removeID={handleremoveItemcomplaint}
                    />
                    <Box style={{ marginTop: '1.75em' }} />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </AnimatedPage>
      </Grid>
    </Grid>
  );
};

export default WarningComplaintPresenter;
